import { ShopflowDeviceInfo } from './plugin';
import { reactive, readonly } from 'vue';
import { isAndroidPluginAvailable } from '../utils';

const PLUGIN_NAME = 'ShopflowDeviceInfo';

type DeviceInfoState = {
  apk_version: string | null;
};

const state = reactive<DeviceInfoState>({
  apk_version: null,
});

export const useDeviceInfo_v2 = () => {
  const getApkVersion = async () => {
    if (!isAndroidPluginAvailable(PLUGIN_NAME)) return null;
    if (state.apk_version) return state.apk_version;

    const { apk_version } = await ShopflowDeviceInfo.getApkVersion();

    return apk_version;
  };

  const init = async () => {
    if (!isAndroidPluginAvailable(PLUGIN_NAME)) return;
    
    const apk_version = await getApkVersion();

    state.apk_version = apk_version;
  };

  return {
    state: readonly(state),
    init,
    getApkVersion,
    isAndroidPluginAvailable,
  };
};
